<template>
    <div>
        <div class="row no-gutters justify-content-start align-items-center common-step-head">
            <img
                src="../assets/images/step_icon.png"
                alt="step"
            />
            <p>{{$t('stepThree.title')}}</p>
        </div>
        <div class="progress custom-progress">
            <div
                class="progress-bar"
                role="progressbar"
                style="width: 75%"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
            ></div>
        </div>
        <div class="comment-content">
            <p>
                {{$t('stepThree.desp')}}
            </p>
            <div>
                <div class="form-group custom-input">
                    <label>{{$t('stepThree.commentTitle')}}</label>
                    <!-- 此处评论内容来自上一个页面的评论填写，不可编辑 -->
                    <textarea
                        rows="3"
                        v-model="$store.state.stepTwo.commentValue"
                        maxlength="20000"
                        :placeholder="$t('stepThree.defaultComment')"
                        readonly
                    ></textarea>
                </div>
                <div class="row no-gutters justify-content-start">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
                        <button
                            type="button"
                            class="common-comfirm-btn link-btn"
                            v-clipboard:copy="$store.state.stepTwo.commentValue"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                        >
                            {{$t('stepThree.btnCopyPost')}}
                            <i class="show-pc"></i>
                            <a
                                :href="linkUrl"
                                target="_blank"
                                class="out-link"
                            ></a>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 首次确定弹框 -->
        <common-modal
            :isShow="isShow"
            :tipMsg="tipMsg"
            :canLink="false"
            :isBtnGroup="isBtnGroup"
            @closeEvent="closeEvent()"
            @cancelEvent="cancelEvent()"
            @confirmEvent="confirmEvent()"
        ></common-modal>
        <!-- 再次确定弹框 -->
        <common-modal
            :isShow="isShowAgain"
            :tipMsg="tipMsgAgain"
            :canLink="true"
            :linkUrl="linkUrl"
            :isBtnGroup="isBtnGroup"
            @closeEvent="closeEvent()"
            @cancelEvent="cancelEventAgain()"
            @confirmEvent="confirmEventAgain()"
        ></common-modal>

    </div>
</template>

<script>

import CommonModal from '../components/CommonModal'
export default {
    name: 'StepThree',
    data() {
        return {
            linkUrl: `https://www.${this.$store.state.salesChannel}/review/review-your-purchases?asin=${this.$store.state.amazonProductASIN}`, // 跳转亚马逊订单进行评论
            isShow: false,   //  是否显示弹框
            tipMsg: this.$t('commonModal.msgContents[1]'),  //  弹框提示内容
            isShowAgain: false,
            tipMsgAgain: this.$t('commonModal.msgContents[2]'),  //  弹框提示内容
            isBtnGroup: true,   //  组件显示按钮个数  true为两个  false 为一个
        }

    },
    components: {
        CommonModal
    },
    methods: {
        // 点击按钮 复制文本 跳转亚马逊评论页面 弹出是否完成评论弹框
        onCopy() {
            // console.log('success');
            this.isShow = true
        },
        // 复制失败
        onError() {
            console.log('error')
        },
        // 弹框关闭事件
        closeEvent() {
            this.isShow = false
            this.isShowAgain = false
        },
        // 弹框取消事件
        cancelEvent() {
            this.isShow = false
            this.isShowAgain = true
        },
        // 弹框确定事件
        confirmEvent() {
            this.isShow = false
            this.$router.push({ path: '/address' })
        },
        cancelEventAgain() {
            this.isShowAgain = false
            this.$router.push({ path: '/address' })
        },
        // 再次确认 弹框确定事件
        confirmEventAgain() {
            this.isShowAgain = false
            this.isShow = true
        }
    }
}
</script>

<style scoped>
.comment-content {
    padding: 0 60px 60px 60px;
}

.comment-content > p {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 40px;
    color: #c6a85b;
    line-height: 38px;
}

.comment-content label {
    font-size: 24px;
}

.comment-content .comment-value {
    padding: 20px;
    min-height: 105px;
    background: #f7f7f7;
}

.link-btn {
    width: 100%;
    position: relative;
}

.link-btn i {
    display: inline-block;
    width: 45px;
    height: 22px;
    background: url('../assets/images/left_icon.png') no-repeat;
    background-size: contain;
    margin-left: 10px;
    vertical-align: middle;
}

.out-link {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
    .comment-content {
        padding: 0 20px;
    }
    .comment-content > p {
        font-size: 20px;
        line-height: 26px;
    }
    .comment-content label {
        font-size: 16px;
    }
}
</style>